import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PayCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/PayCircleOutlined";
import AntdIcon from '../components/AntdIcon';
var PayCircleOutlined = function PayCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: PayCircleOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(PayCircleOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'PayCircleOutlined';
}
export default RefIcon;